module.exports = __webpack_public_path__ + "img/shareimg.145de42d.png";